import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card mt-3" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Website changelog", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { id: "2023-08-14" }, "2023-08-14", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Add RSS and Atom feeds")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { id: "2023-05-04" }, "2023-05-04", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { id: "2023-05-03" }, "2023-05-03", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Use websocket connection for all API requests"),
  /*#__PURE__*/_createElementVNode("li", null, "Redirect to previous page after auth")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { id: "2023-04-25" }, "2023-04-25", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Migrated all site settings from local storage into cookies"),
  /*#__PURE__*/_createElementVNode("li", null, "Improved and re-enabled server side rendering for all pages")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", { id: "2022-11-22" }, "2022-11-22", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { id: "2022-10-20" }, "2022-10-20", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Add ability to update bio in user profile")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", { id: "2022-08-18" }, "2022-08-18", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("li", null, "Add advanced querying in tracker", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", { id: "2021-10-20" }, "2021-10-20", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Fixed notification links")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", { id: "2021-09-14" }, "2021-09-14", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Always show navbar on top"),
  /*#__PURE__*/_createElementVNode("li", null, "Implemented another possible fix for navbar collapsing")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", { id: "2021-09-04" }, "2021-09-04", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", { id: "2021-08-26" }, "2021-08-26", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("li", null, "Added trackers for game and website", -1)
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<h3 id=\"2021-08-05\">2021-08-05</h3><ul><li>Added footer</li><li>Show comment count and score on forum post listing</li><li>Submit comments with CTRL+Enter</li></ul><h3 id=\"2021-07-27\">2021-07-27</h3><ul><li>Added sentry monitoring</li></ul><h3 id=\"2021-07-26\">2021-07-26</h3><ul><li>Added user mentions, only visually for now</li><li>Links that lead to external pages are marked</li><li>Added links to markdown headers</li></ul><h3 id=\"2021-07-22\">2021-07-22</h3><ul><li>Updated site to Bootstrap 5</li><li>Improved SSR implementation</li><li>Fixed manual pagination not working with JavaScript disabled</li></ul><h3 id=\"2021-07-07\">2021-07-07</h3><ul><li>Populated history in user pages</li></ul><h3 id=\"2021-07-04\">2021-07-04</h3><ul><li>Added infinite and manual pagination to forum page</li></ul><h3 id=\"2021-07-02\">2021-07-02</h3><ul><li>Fixed comments sometimes failing to submit</li><li>Add switch for server-side rendering</li><li>Fixed comment editing</li><li>Improve newsletter page experience</li></ul><h3 id=\"2021-06-30\">2021-06-30</h3><ul><li>Replaced YouTube embeds with a lighter solution that only loads the video when you click on it</li></ul><h3 id=\"2021-06-29\">2021-06-29</h3><ul><li>Website is now using SSR, improving embeds in other sites and usability when JavaScript is disabled</li></ul><h3 id=\"2021-04-30\">2021-04-30</h3><ul><li>Preserve comment box text while submitting</li><li>Made horizontal separators more visible</li><li>Matched headers and navbar size between light and dark mode</li><li>Added site settings page</li><li>Moved theme switch to settings page</li><li>Added automatic theme, which matches your browser/OS&#39;s theme preference</li><li>Added confirmation if you exit a page with text in a box</li><li>Added setting for time label format</li><li>Added setting to store comment drafts when cancelling</li><li>Settings will apply if changed on a different tab</li></ul><h3 id=\"2021-04-29\">2021-04-29</h3><ul><li>Added text box with short link on posts</li><li>Replaced &quot;Logged in as&quot; text in navbar with user picture</li></ul><h3 id=\"2021-04-19\">2021-04-19</h3><ul><li>Only automatically scroll when changing pages if the user hasn&#39;t manually scrolled</li></ul><h3 id=\"2021-04-18\">2021-04-18</h3><ul><li>Upload and add images to posts</li><li>User picture on comments are now links to their profile</li></ul><h3 id=\"2021-04-17\">2021-04-17</h3><ul><li>Readded profile pictures</li><li>Added developer flair</li><li>Fixed user pages infinitely loading</li></ul><h3 id=\"2021-03-24\">2021-03-24</h3><ul><li>Readded social links to navbar</li><li>Added loading screen</li><li>Added cancel button on comment reply box</li><li>Show forum description on forum post list</li></ul><h3 id=\"2021-03-21\">2021-03-21</h3><ul><li>Added cool error page</li><li>Redesigned comment action buttons</li></ul><h3 id=\"2021-03-19\">2021-03-19</h3><ul><li>Added spinny inverter loading symbol</li><li>Added super secret link</li><li>Reworked backend</li></ul><h3 id=\"2020-11-04\">2020-11-04</h3><ul><li>Added notifications panel modal, accessible through the navbar</li></ul><h3 id=\"2020-10-24\">2020-10-24</h3><ul><li>Anonymous users can now subscribe to the newsletter</li></ul><h3 id=\"2020-10-23\">2020-10-23</h3><ul><li>Comments can now be collapsed</li></ul><h3 id=\"2020-10-22\">2020-10-22</h3><ul><li>Fixed timestamp tooltips not updating</li><li>Add link on user dropdown to profile page</li><li>Fixed wishlist page looking bad on mobile</li></ul><h3 id=\"2020-10-21\">2020-10-21</h3><ul><li>Timestamps will now refresh every 30 seconds</li><li>Remember scroll position after all content loads when reloading the page</li><li>Fixed comment permalinks not working</li><li>Fixed comment quotes and dark theme colors</li><li>Added comment editing</li><li>Fixed comments not being sorted by date</li></ul><h3 id=\"2020-10-20\">2020-10-20</h3><ul><li>Show post edit time</li></ul><h3 id=\"2020-10-15\">2020-10-15</h3><ul><li>Re-added dark theme</li></ul><h3 id=\"2020-10-14\">2020-10-14</h3><ul><li>Fixed comment delete button not showing</li><li>You can now delete posts if you&#39;re the author</li><li>You can now edit your post&#39;s title and body</li></ul><h3 id=\"2020-10-09\">2020-10-09</h3><ul><li>Added temporary user profile page</li></ul><h3 id=\"2020-10-07\">2020-10-07</h3><ul><li>Rewritten site in Vue.js</li></ul><h3 id=\"2020-09-10\">2020-09-10</h3><ul><li>Removed release hint in home page</li><li>Fixed newlines in comments</li></ul><h3 id=\"2020-07-19\">2020-07-19</h3><ul><li>Added footer</li><li>Added changelog page</li><li>Added wishlist page</li><li>Added tooltips to all icon buttons</li><li>Made logged-in navbar action buttons (settings and logout) more intuitive</li><li>Made post like button more clearly indicate if you&#39;ve already liked it</li><li>Post author can now be clicked on forum post listing</li><li>Re-added markdown quotes</li><li>When replying to a comment, only that comment will now be shown</li></ul>", 58)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TitleTag = _resolveComponent("TitleTag")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TitleTag, { title: "Website changelog" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createTextVNode("Fix comments sometimes being visually duplicated after submission ("),
              _createVNode(_component_router_link, { to: "/tracker/258" }, {
                default: _withCtx(() => [
                  _createTextVNode("#258")
                ]),
                _: 1
              }),
              _createTextVNode(")")
            ])
          ]),
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createTextVNode("Fix website not working on Safari ("),
              _createVNode(_component_router_link, { to: "/tracker/171" }, {
                default: _withCtx(() => [
                  _createTextVNode("#171")
                ]),
                _: 1
              }),
              _createTextVNode(")")
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("Fix 'edit bio' button showing on other users' profiles ("),
              _createVNode(_component_router_link, { to: "/tracker/441" }, {
                default: _withCtx(() => [
                  _createTextVNode("#441")
                ]),
                _: 1
              }),
              _createTextVNode(")")
            ])
          ]),
          _hoisted_14,
          _hoisted_15,
          _hoisted_16,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createTextVNode("Fix submitting a ticket not redirecting you to the new ticket ("),
              _createVNode(_component_router_link, { to: "/tracker/257" }, {
                default: _withCtx(() => [
                  _createTextVNode("#257")
                ]),
                _: 1
              }),
              _createTextVNode(")")
            ]),
            _hoisted_17,
            _createElementVNode("li", null, [
              _createTextVNode("Make carousel arrows more visible ("),
              _createVNode(_component_router_link, { to: "/tracker/403" }, {
                default: _withCtx(() => [
                  _createTextVNode("#403")
                ]),
                _: 1
              }),
              _createTextVNode(")")
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("Warn users if images in posts aren't added ("),
              _createVNode(_component_router_link, { to: "/tracker/184" }, {
                default: _withCtx(() => [
                  _createTextVNode("#184")
                ]),
                _: 1
              }),
              _createTextVNode(")")
            ])
          ]),
          _hoisted_18,
          _hoisted_19,
          _hoisted_20,
          _hoisted_21,
          _hoisted_22,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createTextVNode("Fixed /view/lwt-XXXXXXXX links ("),
              _createVNode(_component_router_link, { to: "/tracker/27" }, {
                default: _withCtx(() => [
                  _createTextVNode("#27")
                ]),
                _: 1
              }),
              _createTextVNode(")")
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("Fixed users without profile pictures seeing an empty image in navbar ("),
              _createVNode(_component_router_link, { to: "/tracker/17" }, {
                default: _withCtx(() => [
                  _createTextVNode("#17")
                ]),
                _: 1
              }),
              _createTextVNode(")")
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("Improved scroll restoring behaviour ("),
              _createVNode(_component_router_link, { to: "/tracker/20" }, {
                default: _withCtx(() => [
                  _createTextVNode("#20")
                ]),
                _: 1
              }),
              _createTextVNode(")")
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("Redirect old forum and image links ("),
              _createVNode(_component_router_link, { to: "/tracker/10" }, {
                default: _withCtx(() => [
                  _createTextVNode("#10")
                ]),
                _: 1
              }),
              _createTextVNode(")")
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("Fixed mobile navbar collapse ("),
              _createVNode(_component_router_link, { to: "/tracker/21" }, {
                default: _withCtx(() => [
                  _createTextVNode("#21")
                ]),
                _: 1
              }),
              _createTextVNode(")")
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("Clarified ticket edit cancel wording ("),
              _createVNode(_component_router_link, { to: "/tracker/25" }, {
                default: _withCtx(() => [
                  _createTextVNode("#25")
                ]),
                _: 1
              }),
              _createTextVNode(")")
            ])
          ]),
          _hoisted_23,
          _createElementVNode("ul", null, [
            _hoisted_24,
            _createElementVNode("li", null, [
              _createTextVNode("Automatically resize comment boxes to fit content ("),
              _createVNode(_component_router_link, { to: "/tracker/4" }, {
                default: _withCtx(() => [
                  _createTextVNode("#4")
                ]),
                _: 1
              }),
              _createTextVNode(")")
            ])
          ]),
          _hoisted_25
        ])
      ])
    ])
  ], 64))
}